<template>
  <li
    v-if="menuItemIsAvailable()"
    class="nav-item has-sub"
    :class="{
      'open': isOpen && isMouseHovered,
      'disabled': item.disabled,
      'sidebar-group-active': isActive,
    }"
  >
    <b-link
      class="d-flex align-items-center"
      @click="() => updateGroupOpen(!isOpen)"
    >
      <feather-icon :icon="item.icon || 'CircleIcon'" />
      <span class="menu-title text-truncate">{{ $t(item.title) }}</span>
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
    </b-link>
    <b-collapse
      v-if="hasEnabledChildren()"
      v-model="isOpen"
      class="menu-content"
      tag="ul"
    >
      <component
        :is="resolveNavItemComponent(child)"
        v-for="child in item.children"
        :key="child.header || child.title"
        ref="groupChild"
        :item="child"
      />
    </b-collapse>
    <ul
      v-else-if="isOpen"
      class="menu-content collapse show empty"
    >
      <li class="nav-item">
        <span class="menu-title text-truncate">Нет доступных разделов</span>
      </li>
    </ul>
  </li>
</template>

<script>
import { BLink, BBadge, BCollapse } from 'bootstrap-vue'
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from '@/core/layouts/utils'
import VerticalNavMenuHeader
  from '@/core/layouts/layout-vertical/components/vertical-nav-menu/components/vertical-nav-menu-header'
import VerticalNavMenuLink
  from '@/core/layouts/layout-vertical/components/vertical-nav-menu/components/vertical-nav-menu-link/VerticalNavMenuLink.vue'

// Composition Function
import useVerticalNavMenuGroup
  from '@/core/layouts/layout-vertical/components/vertical-nav-menu/components/vertical-nav-menu-group/useVerticalNavMenuGroup'
import mixinVerticalNavMenuGroup
  from '@/core/layouts/layout-vertical/components/vertical-nav-menu/components/vertical-nav-menu-group/mixinVerticalNavMenuGroup'
import { getUserData } from '@/auth/utils'
import { integratorIsDentalLaboratory } from '@/composables/currentUser'

export default {
  name: 'VerticalNavMenuGroup',
  components: {
    VerticalNavMenuHeader,
    VerticalNavMenuLink,
    BLink,
    BBadge,
    BCollapse,
  },
  mixins: [mixinVerticalNavMenuGroup],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const {
      isOpen,
      isActive,
      updateGroupOpen,
      updateIsActive,
      isMouseHovered,
    } = useVerticalNavMenuGroup(props.item)

    const isArr = (o) => {
      return Array.isArray(o)
    }

    return {
      resolveNavItemComponent,
      isOpen,
      isActive,
      updateGroupOpen,
      updateIsActive,
      isArr,
      isMouseHovered,
    }
  },
  methods: {
    menuItemIsAvailable() {
      if (!this.menuItemIsAvailableByIntegratorModuleSettings()) {
        return false
      }
      if (this.item.route === 'dictionary-dental-laboratory' && !integratorIsDentalLaboratory()) {
        return false
      }
      return this.item.children.some(
        i => i.children
          ? i.children.some(it => this.$can(it.action, it.resource))
          : this.isArr(i.resource)
            ? i.resource.some(r => this.$can(i.action, r))
            : this.$can(i.action, i.resource)
      )
    },
    menuItemIsAvailableByIntegratorModuleSettings() {
      const user = getUserData()
      if (user) {
        if (user.isRoot) {
          return true
        }
        return user.system_modules.includes(this.item.route)
      }
      return true
    },
    hasEnabledChildren() {
      const user = getUserData()
      if (user) {
        if (user.isRoot) {
          return true
        }
        return this.item.children.findIndex(child => user.system_modules.includes(child.route)) > -1
      }
      return true
    }
  }
}
</script>

<style lang='scss'>

@import '@/assets/scss/style';

.nav-item.has-sub.open {
  .menu-content.empty {
    display: flex;
    align-items: center;
    justify-content: center;
    .menu-title {
      font-style: italic;
      font-size: 13px;
    }
  }
}
.dark-layout {
  .nav-item.has-sub.open {
    .menu-content.empty {
      .menu-title {
        color: $theme-dark-label-color;
      }
    }
  }
}
</style>
